const getters = {
    budgets: state => state.budgets,
    loading: state => state.loading
};

export default getters;
